<template>
  <div>
    <div class="small">{{ $t('passwordMustInclude') }}:</div>
    <ul class="unstyled-list" aria-live="assertive">
      <WCValidationMessage :isValid="passwordRequirementsMet.minLength" role="listitem">
        <font-awesome-icon
          class="mr-2"
          :class="passwordRequirementsMet.minLength ? 'text-success' : 'text-danger'"
          :icon="xOrCheck(passwordRequirementsMet.minLength)"
          :title="
            (passwordRequirementsMet.minLength ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationCharLength')
          "
          :aria-label="
            (passwordRequirementsMet.minLength ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationCharLength')
          "
        />
        <span aria-hidden="true">{{ $t('passwordValidationCharLength') }}</span>
      </WCValidationMessage>
      <WCValidationMessage :isValid="passwordRequirementsMet.upper" role="listitem">
        <font-awesome-icon
          class="mr-2"
          :class="passwordRequirementsMet.upper ? 'text-success' : 'text-danger'"
          :icon="xOrCheck(passwordRequirementsMet.upper)"
          :title="
            (passwordRequirementsMet.upper ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationUpperCase')
          "
          :aria-label="
            (passwordRequirementsMet.upper ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationUpperCase')
          "
        />
        <span aria-hidden="true">{{ $t('passwordValidationUpperCase') }}</span>
      </WCValidationMessage>
      <WCValidationMessage :isValid="passwordRequirementsMet.number" role="listitem">
        <font-awesome-icon
          class="mr-2"
          :class="passwordRequirementsMet.number ? 'text-success' : 'text-danger'"
          :icon="xOrCheck(passwordRequirementsMet.number)"
          :title="
            (passwordRequirementsMet.number ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationNumber')
          "
          :aria-label="
            (passwordRequirementsMet.number ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationNumber')
          "
        />
        <span aria-hidden="true">{{ $t('passwordValidationNumber') }}</span>
      </WCValidationMessage>
      <WCValidationMessage :isValid="passwordRequirementsMet.symbol" role="listitem">
        <font-awesome-icon
          class="mr-2"
          :class="passwordRequirementsMet.symbol ? 'text-success' : 'text-danger'"
          :icon="xOrCheck(passwordRequirementsMet.symbol)"
          :title="
            (passwordRequirementsMet.symbol ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationSymbol')
          "
          :aria-label="
            (passwordRequirementsMet.symbol ? $t('passed') : $t('failed')) +
              ' ' +
              $t('passwordValidationSymbol')
          "
        />
        <span aria-hidden="true">{{ $t('passwordValidationSymbol') }}</span>
      </WCValidationMessage>
    </ul>
  </div>
</template>

<script>
import WCValidationMessage from '@/modules/forms/components/WCValidationMessage/WCValidationMessage.vue';

export default {
  name: 'WCPasswordValidationMessages',
  components: { WCValidationMessage },
  props: {
    validationState: {
      type: Object,
    },
  },
  computed: {
    passwordRequirementsMet() {
      return this.validationState
        ? this.validationState.requirementsMet
        : { minLength: false, upper: false, number: false, symbol: false };
    },
  },
  methods: {
    xOrCheck(isValid) {
      return isValid ? 'check' : 'xmark';
    },
  },
};
</script>

<style scoped>
.unstyled-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
